import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IncidentFormControls } from 'src/app/types';

type IncidentType = 'cancellation' | 'underringing' | 'walkout' | 'cashier';

const incidentTypeProperties: Record<IncidentType, { id: string; formControlName: string; label: string }> = {
  cancellation: {
    id: 'isCancellation',
    formControlName: 'is_cancellation',
    label: 'Cancellation',
  },
  underringing: {
    id: 'isUnderringing',
    formControlName: 'is_underringing',
    label: 'Underringing',
  },
  walkout: {
    id: 'isWalkout',
    formControlName: 'is_walkout',
    label: 'Walkout',
  },
  cashier: {
    id: 'isCashier',
    formControlName: 'is_cashier',
    label: 'Cashier',
  },
};

@Component({
  selector: 'app-review-form-incident-type',
  templateUrl: './review-form-incident-type.component.html',
  styleUrl: './review-form-incident-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormIncidentTypeComponent {
  public form = input.required<FormGroup<IncidentFormControls>>();
  public incidentTypes = input<IncidentType[]>(['cancellation', 'underringing', 'walkout', 'cashier']);
  public exclusive = input<boolean>(false);

  public incidentTypeRefs = computed(() => this.incidentTypes().map((type) => incidentTypeProperties[type]));

  public onIncidentTypeChange(selectedControlName: string, event: Event) {
    if (!this.exclusive() || !(event.target as HTMLInputElement).checked) return;

    this.incidentTypeRefs()
      .filter((type) => type.formControlName !== selectedControlName)
      .forEach((type) => this.form().controls.theftType.get(type.formControlName)?.setValue(false));
  }
}
